export enum PathOptions {
  Asset_Finance,
  Residential,
  Commercial,
  Other_Financial_Enquiries,
}

export enum IncomeOptions {
  PAYG_Employed,
  Sole_Trader,
  Company,
  Trust,
  Contract
}

export enum ApplicationOptions {
  Refinance,
  First_Home_Buyer,
  Investor,
  Retirement,
}

export enum ProjectOptions {
  Established,
  Construction,
  Off_The_Plan,
  SMSF,
  Reverse_Mortgage,
}